import { createApp } from 'vue'
import router from './router'
import ElementPlus from 'element-plus'
import Layout from './components/Layout.vue'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
const app = createApp(App)
import Vue3Signature from 'vue3-signature'

app.use(Vue3Signature)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.component('LayoutComponentBase', Layout)
app.use(ElementPlus)
app.use(router)
const resizeObserverErr = window.onerror
window.onerror = function(err) {
  if(err.includes('ResizeObserver')) return
  resizeObserverErr.apply(this, arguments)
}
app.mount('#app')